import { FC } from "react";

import {
	getSurfaceBorderStyle,
} from "@/app/application/theme";
import { ArchiveProcedureSearch } from "@/features/archive/pages/archive-procedure/components/ArchiveProcedureSearch";
import {
	alpha,
	Card,
	CardContent,
	useTheme,
} from "@mui/material";

type Props = {
	startDate: Date;
	endDate: Date;
	selectedUser: number;
	setStartDate: (d: Date) => void;
	setEndDate: (d: Date) => void;
	setSelectedUser: (u: number) => void;
	setDateRange: (start: Date, end: Date) => void;
};

export const ArchiveProcedureFilterBar: FC<Props> = ({
	startDate,
	endDate,
	selectedUser,
	setStartDate,
	setEndDate,
	setSelectedUser,
	setDateRange,
}) => {
	const theme = useTheme();

	return (
		<Card
			variant="outlined"
			sx={{
				borderRadius: { xs: 2, sm: 3 },
				border: getSurfaceBorderStyle(theme, "strong"),
				backgroundColor: theme.palette.background.paper,
				boxShadow:
					theme.palette.mode === "dark"
						? `0 1px 0 ${alpha(theme.palette.common.white, 0.04)}`
						: `0 1px 2px ${alpha(theme.palette.common.black, 0.04)}`,
				height: "100%",
			}}
		>
			<CardContent
				sx={{
					px: { xs: 2, sm: 2.5 },
					py: { xs: 1.5, sm: 1.75 },
					"&:last-child": { pb: { xs: 1.5, sm: 1.75 } },
				}}
			>
				<ArchiveProcedureSearch
					startDate={startDate}
					endDate={endDate}
					selectedUser={selectedUser}
					SetStartDate={setStartDate}
					SetEndDate={setEndDate}
					SetSelectedUser={setSelectedUser}
					SetDateRange={setDateRange}
				/>
			</CardContent>
		</Card>
	);
};
